<template lang="pug">
  .layout
    .cover
    article
      .wrapper
        .information
          .top
            h1 55th Reunion Central Bucks East and West class of 1970
            h2 Saturday June 7th, 2025   -------  The Inn at Fox Briar Farm

      .page#top
        .page-wrapper
          .navigation.top
            a.button(href="/payments") Registration Payment
            router-link.button(to="/attending") Classmates Attending
            router-link.button(to="/faq") FAQ
            router-link.button(to="/") Missing Classmates
          .navigation.bottom
            router-link.button(to="/survey") Survey
            router-link.button(to="/west") West Yearbook
            router-link.button(to="/east") East Yearbook
            router-link.button(to="/slideshow") Yearbook Slideshow
          .navigation.bottom
            router-link.button(to="/reunion") 50th Reunion Photos May 21, 2022
            //-router-link.button(to="/precautions") Covid Precautions
          router-view
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}

</script>

<style lang="stylus">
#app

  .navigation
    background #fff
    padding 5px 20px
    text-align center
    a.button
      background-color #ddd
      color #2c3e50
      display inline-block
      margin 10px
      width 160px
      &.router-link-exact-active
        background-color darken(#4287f5, 10%) !important
        color #fff
    &.top
      padding-top 20px
    &.bottom
      padding-bottom 20px
  h1
    margin-bottom 10px
  h2
    font-size 20px
    margin 0
    margin-bottom 10px

  a.button:hover
    background-color darken(#4287f5, 10%) !important
    color #fff


  .cover
    background url('../assets/reunion_cover.jpg')
    background-size cover
    background-position center center
    //box-shadow 0 2px 10px rgba(0,0,0,1)
    height 70vh
    top 0
    left 0
    width 100%
    position fixed
    z-index 1

  .wrapper
    .top
      background rgba(66, 135, 245, .9)
      color #fff
      padding 10px 20px
      text-align center

  .button
    background-color lighten(#4287f5,10%)
    color #fff
    display block
    padding 10px
    text-align center
    text-decoration none
    &:hover
      background-color darken(#4287f5, 10%)
      

</style>
